export const defaultNavPath = ['/', '/locationreq', '/installtype'];

function addPanelAmpsPhase(navPath) {
  const makeModelNavIndex = navPath.findIndex(element => {
    return element === '/makemodel';
  });
  const panelAmpsPhaseNavIndex = navPath.findIndex(element => {
    return element === '/panelampsphase';
  });
  if (makeModelNavIndex >= 0 && panelAmpsPhaseNavIndex < 0) {
    navPath.splice(makeModelNavIndex + 1, 0, '/panelampsphase');
  }
}

function addPhaseConnection(navPath) {
  const panelAmpsPhaseNavIndex = navPath.findIndex(element => {
    return element === '/panelampsphase';
  });
  const phaseConnectionNavIndex = navPath.findIndex(element => {
    return element === '/phaseconnection';
  });
  if (panelAmpsPhaseNavIndex >= 0 && phaseConnectionNavIndex < 0) {
    navPath.splice(panelAmpsPhaseNavIndex + 1, 0, '/phaseconnection');
  }
}

function addTerminalBlock(navPath) {
  const phaseConnectionNavIndex = navPath.findIndex(element => {
    return element === '/phaseconnection';
  });
  const terminalBlockIndex = navPath.findIndex(element => {
    return element === '/terminalblock';
  });
  if (phaseConnectionNavIndex >= 0 && terminalBlockIndex < 0) {
    navPath.splice(phaseConnectionNavIndex + 1, 0, '/terminalblock');
  }
}

function removePanelAmpsPhase(navPath) {
  const panelAmpsPhaseNavIndex = navPath.findIndex(element => {
    return element === '/panelampsphase';
  });
  if (panelAmpsPhaseNavIndex >= 0) {
    navPath.splice(panelAmpsPhaseNavIndex, 1);
  }
}

function removePhaseConnection(navPath) {
  const phaseConnectionNavIndex = navPath.findIndex(element => {
    return element === '/phaseconnection';
  });
  if (phaseConnectionNavIndex >= 0) {
    navPath.splice(phaseConnectionNavIndex, 1);
  }
}

function removeTerminalBlock(navPath) {
  const terminalBlockIndex = navPath.findIndex(element => {
    return element === '/terminalblock';
  });
  if (terminalBlockIndex >= 0) {
    navPath.splice(terminalBlockIndex, 1);
  }
}

function handleAlbSmartMeter(navPath, globalData) {
  const makeModelNavIndex = navPath.findIndex(element => {
    return element === '/makemodel';
  });
  const albSmartMeterNavIndex = navPath.findIndex(element => {
    return element === '/albsmartmeter';
  });

  if (globalData.isAlbSupported) {
    if (makeModelNavIndex >= 0 && albSmartMeterNavIndex < 0) {
      navPath.splice(makeModelNavIndex + 1, 0, '/albsmartmeter');
    }
  } else if (albSmartMeterNavIndex >= 0) {
    navPath.splice(albSmartMeterNavIndex, 1);
  }
}

function handleOCPP1PhaseStations(navPath) {
  removeTerminalBlock(navPath);
}

function handleOCPP3PhaseStations(navPath) {
  addTerminalBlock(navPath);
}

function handle1PhasePanel(navPath) {
  removePhaseConnection(navPath);
  removeTerminalBlock(navPath);
}

function handle3PhasePanel(navPath, globalData) {
  addPhaseConnection(navPath);
  if (globalData.inputPhaseCapability === 'AC_3_PHASE') {
    handleOCPP3PhaseStations(navPath);
  } else {
    handleOCPP1PhaseStations(navPath);
  }
}

function handleOCPPACStations(navPath, incomingData, globalData) {
  addPanelAmpsPhase(navPath);
  if (incomingData.panelPhase === 3) {
    handle3PhasePanel(navPath, globalData);
  } else if (incomingData.panelPhase === 1) {
    handle1PhasePanel(navPath);
  }
}

function handleOCPPDCStations(navPath) {
  removePanelAmpsPhase(navPath);
  removePhaseConnection(navPath);
  removeTerminalBlock(navPath);
}

export function setNavPath(
  currentNav,
  globalData,
  incomingData,
  alreadySavedData
) {
  const navPath = currentNav;
  if (globalData.networkHardwareSwap && incomingData.validMac) {
    return ['/', '/locationreq', '/maclabel', '/successswap'];
  }

  // 3 Phase Station New
  if (
    incomingData.installtype === 'new' &&
    !globalData.isOCPP &&
    globalData.isThreePhase
  ) {
    return [
      '/',
      '/installtype',
      '/address',
      '/addressform',
      '/pinpoint',
      '/stationdetails',
      '/stationphoto',
      '/terminalblock',
      '/stationpin',
      '/success'
    ];
  }

  // Three Phase Station Replace
  if (
    incomingData.installtype === 'replace' &&
    !globalData.isOCPP &&
    globalData.isThreePhase
  ) {
    return [
      '/',
      '/installtype',
      '/maclabel',
      '/terminalblock',
      '/stationpin',
      '/successswap'
    ];
  }

  // Regular Chargepoint Station New
  if (incomingData.installtype === 'new' && !globalData.isOCPP) {
    return [
      '/',
      '/locationreq',
      '/installtype',
      '/address',
      '/addressform',
      '/pinpoint',
      '/stationdetails',
      '/stationphoto',
      '/stationpin',
      '/success'
    ];
  }

  // Regular Chargepoint Station Replace
  if (incomingData.installtype === 'replace' && !globalData.isOCPP) {
    return [
      '/',
      '/locationreq',
      '/installtype',
      '/maclabel',
      '/stationpin',
      '/successswap'
    ];
  }

  // OCPP station New
  if (incomingData.installtype === 'new' && globalData.isOCPP) {
    return [
      '/',
      '/locationreq',
      '/installtype',
      '/makemodel',
      '/address',
      '/addressform',
      '/pinpoint',
      '/stationdetails',
      '/stationphoto',
      '/success'
    ];
  }

  // OCPP station Replace
  if (incomingData.installtype === 'replace' && globalData.isOCPP) {
    return [
      '/',
      '/locationreq',
      '/installtype',
      '/makemodel',
      '/maclabel',
      '/successswap',
      '/success'
    ];
  }

  if (globalData.isOCPP) {
    const ocppNavPath = [...navPath];
    if (
      globalData.inputPhaseCapability &&
      globalData.inputPhaseCapability !== 'DC'
    ) {
      handleOCPPACStations(ocppNavPath, incomingData, globalData);
    } else {
      handleOCPPDCStations(ocppNavPath);
    }

    handleAlbSmartMeter(ocppNavPath, globalData);

    return ocppNavPath;
  }

  // by passing through QR Code URL
  if (alreadySavedData['/installtype']) {
    if (
      alreadySavedData['/installtype'].installtype === 'new' &&
      !globalData.isOCPP &&
      incomingData.validMac
    ) {
      return [
        '/',
        '/locationreq',
        '/address',
        '/addressform',
        '/pinpoint',
        '/stationdetails',
        '/stationphoto',
        '/stationpin',
        '/success'
      ];
    }

    if (
      alreadySavedData['/installtype'].installtype === 'replace' &&
      !globalData.isOCPP &&
      incomingData.validMac
    ) {
      return ['/', '/locationreq', '/maclabel', '/stationpin', '/successswap'];
    }
  }

  return navPath;
}
